<block-ui>
    <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs justify-content-left">
        <li [ngbNavItem]="1">
            <a ngbNavLink><b>Asignación de roles</b></a>
            <ng-template ngbNavContent>
                <app-rol-assigns></app-rol-assigns>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink><b>Roles</b></a>
            <ng-template ngbNavContent>
                <app-roles></app-roles>
            </ng-template>
        </li>
        <li [ngbNavItem]="3">
            <a ngbNavLink><b>Permisos</b></a>
            <ng-template ngbNavContent>
                <app-permissions></app-permissions>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</block-ui>